import React from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  redirectURL,
  Service_CN,
  Service_GL
} from "../../../../utils/CommonFunc";
import { SIGN_IN_URL, SIGN_UP_URL } from "../../../../utils/config/Config";
import Language from "../../language/Language";
import { useRecoilValue } from "recoil";
import { isLauncherState } from "../../../../recoil/userInfoAtom";

interface IProps {
  type: string;
  addclassname: string;
}

function LoginBtn(props: IProps) {
  const { type, addclassname } = props;
  const { t } = useTranslation();
  const { service_code } = useParams();
  const isLauncher = useRecoilValue(isLauncherState);

  const onClickSignIn = () => {
    if (isLauncher) {
      window.app.vfunRequestLogin();
    } else {
      redirectURL(SIGN_IN_URL(service_code || "vfun"), "_self", isLauncher);
    }
  };

  const onClickSignUp = () => {
    if (isLauncher) {
      window.app.vfunRequestLogin();
    } else {
      redirectURL(SIGN_UP_URL(service_code || "vfun"), "_self", isLauncher);
    }
  };

  return (
    <ul className={`${addclassname} pull-right`}>
      {Service_GL && !Service_CN
        ? type === "combine" && (
            <li>
              <Language />
            </li>
          )
        : null}
      <li className="login">
        <Link to="#" onClick={onClickSignIn}>
          {t("signin")}
        </Link>
      </li>
      <li className="signup">
        <Link to="#" onClick={onClickSignUp}>
          {t("signup")}
        </Link>
      </li>
      {Service_GL && !Service_CN
        ? type === "side" && (
            <li>
              <Language />
            </li>
          )
        : null}
    </ul>
  );
}

export default React.memo(withTranslation()(LoginBtn));
